import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import { Link } from 'library/util/core-router';
import withUser from 'util/hoc/with-user';
import MatchScore from 'library/components/target-match-score';
import DownloadReportButton from 'library/components/download-report';
import TargetGroupingData from 'apps/personal/components/targets/grouping-data';
import TargetRange from 'apps/personal/components/targets-target-range';
import TargetLoading from 'apps/personal/components/targets/target-loading';
import TargetDescription from 'apps/personal/components/targets/description';

export const TargetDataLoading = () => (
  <Fragment>
    <div className="personal-target-grouping-targets-list">
      <label key="match-label">{trans`MATCH`}</label>
      <a href="javascript:void(0)">loading</a>
      <a href="javascript:void(0)">loading</a>
      <a href="javascript:void(0)">loading</a>
      <label key="match-label">{trans`GAP`}</label>
      <a href="javascript:void(0)">loading</a>
      <a href="javascript:void(0)">loading</a>
      <a href="javascript:void(0)">loading</a>
    </div>
    <div className="personal-target-grouping-targets-body">
      <TargetRange target={{characteristic: {score:50}, percentile_range: {start: 25, end: 75}}} />
      <TargetDescription target={{characteristic:{name:'loading', description:'', content:{insight:'',tip:''}}}} />
    </div>
  </Fragment>
);

class TargetData extends React.Component {
  static propTypes = {
    targetGroupings: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    removeTarget: PropTypes.func
  }

  mapGroupings = ({ match, name, id, targets, isLoading=false }) => (
    <Fragment key={id}>
      <div className='personal-target-grouping'>
        <div className='personal-target-grouping-header'>
          <h3 className='personal-target-grouping-name'>
            { name }
          </h3>
          <div className='personal-target-grouping-options'>
            <a
              href="javascript:void(0)"
              disabled={this.props.loading}
              className='personal-target-grouping-remove'
              onClick={()=>this.props.removeTarget(id)}
            >
              remove this target
            </a>
            <DownloadReportButton
              reportType="personal_readiness"
              data={{
                user_id: Number(resolve(this.props, 'user/id', '')),
                target_id: Number(id),
                organization_id:Number(resolve(this.props, 'currentOrganization', ''))
              }}
            />
          </div>
        </div>
      </div>
      <div className='personal-target-grouping-targets'>
        {
          isLoading
            ? <TargetDataLoading />
            : <TargetGroupingData targets={targets} />
        }
      </div>
    </Fragment>
  )

  render() {
    if (!resolve(this.props, 'targetGroupings', []).length) {
      return (
        <div className="personal-target-grouping-placeholder">
          <div className="personal-target-grouping-placeholder-overlay">
            <h1>No Targets</h1>
            <Link to="/personal/add-target-grouping" className="button">Add Target</Link>
          </div>
          <TargetLoading />
        </div>
      );
    }

    return (
      <Fragment>
        { resolve(this.props, 'targetGroupings', []).map(this.mapGroupings) }
      </Fragment>
    );
  }
}

export default withUser(TargetData);
